import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css, type CSSResult } from 'lit'

const methodAddressWrapper = {
  marginBlock: css`var(--csc-delivery-match-method-address-wrapper-margin-block, ${csSpacing.spacing04} ${csSpacing.spacing06})`
}

export const style: CSSResult = css`
  :host {
    --cse-accordion-simple-header-padding-y: ${csSpacing.spacing04} 0;
  }

  .method-heading {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: ${csSpacing.spacing05};
  }

  .method-distance {
    white-space: nowrap;
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing04};
    margin-top: ${csSpacing.spacing04};
  }

  .method-address-wrapper {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing05};
    margin-block: ${methodAddressWrapper.marginBlock};
  }

  .method-address-wrapper cse-divider {
    align-self: stretch;
  }

  .method-bottom {
    display: flex;
    align-items: flex-start;
  }

  .carrier-image {
    min-width: max-content;
    height: 30px;
    margin-left: auto;
  }

  @media (min-width: ${SCREENS.small}) {
    .carrier-image {
      height: 40px;
    }
  }

  cse-accordion {
    text-align: left;
  }

  .content {
    display: flex;
    align-items: flex-start;
    gap: ${csSpacing.spacing04};
  }

  .opening-hours-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0 ${csSpacing.spacing05};
  }

  csc-delivery-match-method-dropoff-content {
    flex: 1;
  }
`
